export type OrderResponse = {
  session_id: string;
  session_status: 'paid' | 'pending' | 'failed';
  order_status: 'paid' | 'pending' | 'failed';
  order_id: string;
};


export const isFailed = (orderStatus: OrderResponse['order_status']) => {
  return orderStatus === 'failed';
}
